/* eslint-disable no-throw-literal */
import {
  GET_TANOMAIL_LIST,
  GET_TANOMAIL,
  CREATE_MASTER_TANOMAIL,
  UPDATE_MASTER_TANOMAIL,
  DELETE_TANOMAIL,
  STOCK_OUTPUT_TANOMAIL
} from './mutation-types'

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_TANOMAIL_LIST] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/tanomail_id_passwords', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [CREATE_MASTER_TANOMAIL] ({ dispatch }, params) {
      const res = await dispatch('apiPost', { url: '/master/tanomail_id_passwords', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_TANOMAIL] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: `/master/tanomail_id_passwords/${params.id}/edit` })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [DELETE_TANOMAIL] ({ dispatch }, params) {
      const res = await dispatch('apiDelete', { url: `/master/tanomail_id_passwords/${params.id}` })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [UPDATE_MASTER_TANOMAIL] ({ dispatch }, params) {
      const res = await dispatch('apiPatch', { url: `/master/tanomail_id_passwords/${params.data.id}`, data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [STOCK_OUTPUT_TANOMAIL] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: `/master/tanomail_id_passwords/tanomail_csv_download`, data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    }
  },
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/tanomail.js